import { combineReducers } from "redux";

import envReducer from './env';
import logsReducer from './logs';
import userReducer from "./users";
import billReducer from "./bills";
import clientReducer from './clients';
import reportReducer from './reports';
import cifCrossReducer from './cifCross';
import providerReducer from "./providers";
import countriesReducer from "./countries";
import sessionInfoReducer from "./session";
import questionsReducer from './questions';
import creditLineReducer from './credit-line';
import notificationReducer from './notifications';

const rootReducer = (state, action) => {

  if (action.type === 'RESET_APP') {
    const { sessionInfoReducer, envReducer } = state;
    state = { sessionInfoReducer, envReducer };
  }
  return Reducer(state, action);
}

const Reducer = combineReducers({
  envReducer,
  userReducer,
  billReducer,
  logsReducer,
  clientReducer,
  reportReducer,
  providerReducer,
  countriesReducer,
  questionsReducer,
  cifCrossReducer,
  creditLineReducer,
  sessionInfoReducer,
  notificationReducer,
});

export default rootReducer;
